import Vue from "vue";
const templateId = document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/options.js";

import singles from './singles.js';
import multiselect from './multiselect.js';
import doubleinput from './doubleinput.js';

let component = Vue.component("options", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['opt','groupid','jsonval'],
      components: {
        appSingleselect: singles,
        appMultiselect: multiselect,
        appDoubleinput: doubleinput
      },
      data() {
        return {
          urlValue: ''
        }
      },
      mounted() {
        let x = window.location.href
        if (x.indexOf('group_id=') > 0) {
          this.urlValue = x
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/options.js